/**
 * Página de gestión de sucursales
 */
import React, { useState, useEffect } from "react";
import {
  Table,
  Card,
  Space,
  Button,
  Typography,
  message,
  Popconfirm,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { useBranch } from "../context/BranchContext";
import api from "../api/endpoints";
import BranchForm from "../components/branches/BranchForm";

const { Title } = Typography;

const Branches = () => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const { reloadBranches } = useBranch();

  const loadBranches = async () => {
    setLoading(true);
    try {
      const response = await api.branches.list(1);
      setBranches(response.results || []);
    } catch (error) {
      console.error("Error cargando sucursales:", error);
      message.error("Error al cargar sucursales");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBranches();
  }, []);

  const handleCreate = () => {
    setSelectedBranch(null);
    setModalVisible(true);
  };

  const handleEdit = (branch) => {
    setSelectedBranch(branch);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await api.branches.destroy(id);
      message.success("Sucursal eliminada exitosamente");
      loadBranches();
      reloadBranches();
    } catch (error) {
      message.error("Error al eliminar sucursal");
    }
  };

  const handleModalSuccess = () => {
    setModalVisible(false);
    setSelectedBranch(null);
    // Pequeño delay para asegurar que localStorage se actualice
    setTimeout(() => {
      loadBranches();
      reloadBranches();
    }, 100);
  };

  const columns = [
    {
      title: "Nombre Comercial",
      dataIndex: "business_name",
      key: "business_name",
    },
    {
      title: "Giro",
      dataIndex: "commercial_business",
      key: "commercial_business",
    },
    {
      title: "Teléfono",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Comuna",
      dataIndex: "commune",
      key: "commune",
    },
    {
      title: "Acciones",
      key: "actions",
      width: 150,
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          >
            Editar
          </Button>
          <Popconfirm
            title="¿Eliminar esta sucursal?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button type="link" danger icon={<DeleteOutlined />}>
              Eliminar
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Card>
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          <div style={{ 
            display: "flex", 
            flexDirection: "column",
            justifyContent: "space-between", 
            alignItems: "flex-start",
            gap: 16,
          }}
          className="responsive-header"
          >
            <Title level={2} style={{ margin: 0 }}>
              Gestión de Sucursales
            </Title>
            <Space wrap>
              <Button icon={<ReloadOutlined />} onClick={loadBranches}>
                Actualizar
              </Button>
              <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
                Nueva Sucursal
              </Button>
            </Space>
          </div>

          <Table
            columns={columns}
            dataSource={branches}
            loading={loading}
            rowKey="id"
            pagination={{ 
              pageSize: 10,
              responsive: true,
              showSizeChanger: true,
            }}
            scroll={{ x: 800 }}
            responsive
          />
        </Space>
      </Card>

      <BranchForm
        visible={modalVisible}
        branch={selectedBranch}
        onCancel={() => {
          setModalVisible(false);
          setSelectedBranch(null);
        }}
        onSuccess={handleModalSuccess}
      />
    </div>
  );
};

export default Branches;

